// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__177jz","footer":"styles_footer__-p5xO"};